import type { FunctionComponent, ReactNode } from 'react';

import { Icon, type IconicNames, type IconicTypes } from '@clubmed/trident-icons';

export type ButtonContentProps = {
  /**
   * @deprecated
   */
  showLabel?: boolean;
  /**
   * @deprecated
   */
  label?: string;
  children?: ReactNode;
  icon?: IconicNames;
  iconType?: IconicTypes;
  iconWidth?: string;
};

export const ButtonContent: FunctionComponent<ButtonContentProps> = ({
  showLabel,
  label,
  children,
  icon,
  iconType,
  iconWidth,
}) => {
  return (
    <span className="flex items-center justify-center gap-x-8 w-full">
      {showLabel ? label : label && <span className="sr-only">{label}</span>}
      {children}
      {icon && <Icon name={icon} width={iconWidth ?? '24px'} type={iconType} />}
    </span>
  );
};
